import React from 'react'
import xz_logo from '../imageSrc/xz_funtionPageLogo.png'
import './settingTop.css'


class SettingTop extends React.Component {
    constructor(props) {
        super(props)
    }

    onHandleBack = () => {
        this.props.handleBack();
    };

    render(){
        return(
            <div className='div_top_style'>
                <img className='logo_style' src={xz_logo}/>
                <button onClick={this.onHandleBack} className='button_navBack_style'>返 回</button>
            </div>
        );
    }
}

export default SettingTop